import { DomPortalOutlet } from '@angular/cdk/portal';
import { Component, Input } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FileInput } from '../../../models/IFileInput';

@Component({
  selector: 'ff-image-loader-modal',
  templateUrl: './image-loader-modal.component.html',
  styleUrls: ['./image-loader-modal.component.scss']
})
export class ImageLoaderModalComponent {

  constructor() { }

  private bodyPortalOutlet: DomPortalOutlet

  /**
   * Callback that will receive the selected file list
   * and execute the function
   * * @internal
  */
  @Input() onSave: (files: FileInput[]) => void;



  //Method to close the modal
  clear   = () => { this.bodyPortalOutlet.detach(); }

  //Array that will contain selected files
  files: FileInput[] = [];

  /**
   * on file drop handler
   */
   onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

   /**
   * on save button click
   */
  save() {
     if (this.onSave) { this.onSave(this.files); }
     this.clear();
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
   async prepareFilesList(files: Array<any>) {

    for (const item of files) {

      //File extension validation
      let idxDot = item.type.lastIndexOf("/") + 1,
      extFile = item.type.substr(idxDot, item.type.length).toLowerCase();

      if (extFile=="jpg" || extFile=="jpeg" || extFile=="png" || extFile=="gif"){

        item.src = await this.getSource(item).then((value) => {
          return value as string;
        });

        const fileInput = new FileInput();
        fileInput.file = item;
        fileInput.progressSubject = new Subject();
        fileInput.progress = 0;
        fileInput.progressSubject.subscribe(progress => {
          fileInput.progress = progress;

        });
        this.files.push(fileInput);
      }
    }

  }

  //Method to return the url source of the file
  getSource(file: File) {

    return new Promise((res, rej) => {
      // create file reader
      let reader = new FileReader();

      // read file
      reader.readAsDataURL(file);

      // register event listeners
      reader.addEventListener("loadend", e => res(reader.result));
      reader.addEventListener("error", rej);


   });

 }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

}
